export default __webpack_public_path__ + "static/media/RobotoMono-Bold.a505e088.woff2";